// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__l-STQ","calendarButtons":"ClockData_calendarButtons__2P0rM"};